import { Component, Input, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { FilterCompanyAssignmentViewModel, PortfolioDTO } from '../../interface/portfolio.interface';
import { debounceTime, distinctUntilChanged, Subscription } from 'rxjs';

@Component({
  selector: 'app-portfolio-filter-section',
  templateUrl: './portfolio-filter-section.component.html',
  styleUrls: ['./portfolio-filter-section.component.scss']
})
export class PortfolioFilterSectionComponent implements OnInit, OnDestroy{

  @Output()
  public updatedFilters = new EventEmitter<FilterCompanyAssignmentViewModel>;

  @Input() portfolios: Array<PortfolioDTO>

  public filterForm: FormGroup;
  public searchSubscription: Subscription;

  constructor(private fb: FormBuilder) {
    this.portfolios = new Array<PortfolioDTO>;
    this.filterForm = this.fb.group({
      search: '',
      favorite: '',
      selectedPortfolioId: ''
    });
  }

  ngOnInit(): void {


    this.searchSubscription = this.filterForm.controls['search'].valueChanges
    .pipe(
      debounceTime(500),
      distinctUntilChanged()
    ).subscribe(() => {
      this.sendFilter();
    });
  } 

  changeSelect(): void {
    this.sendFilter();
  }

  public sendFilter(): void {
    const search = this.filterForm.get('search').value;
    const favorite = this.filterForm.get('favorite').value;

    const filter: FilterCompanyAssignmentViewModel =  {
      search: search,
      favorite: favorite,
    };
    console.log(filter);
    this.updatedFilters.emit(filter);
  }

  changeFavorite(event: any): void {
    const search = this.filterForm.get('search').value;
    const favorite = event;

    const filter: FilterCompanyAssignmentViewModel =  {
      search: search,
      favorite: favorite,
    };
    this.updatedFilters.emit(filter);
  }

  ngOnDestroy(): void {
    this.searchSubscription.unsubscribe();
  }
}
